import { ShippingCondition as IShippingCondition } from '@cemex-core/cmx-api/models/shipping-conditions/shipping-condition';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import {
  AsyncState,
  asyncFailed,
  asyncStart,
  asyncState,
  asyncSuccess,
  createAsyncState,
} from '@ordersnproducts/utils/create-async-state';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import ShippingConditionActions from '../actions/shipping-condition.actions';

interface ShippingConditionEntityState extends EntityState<IShippingCondition> {
  activeEntityId: number;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ShippingConditionState extends AsyncState<ShippingConditionEntityState> {}

export const adapterShippingCondition: EntityAdapter<IShippingCondition> = createEntityAdapter<IShippingCondition>({
  selectId: ({ shippingConditionId }) => shippingConditionId,
});

export const initialShippingConditionState = createAsyncState({
  ...adapterShippingCondition.getInitialState({
    activeEntityId: null,
  }),
});

export const shippingConditionReducer = createReducer(
  initialShippingConditionState,
  on(ShippingConditionActions.fetch, asyncStart()),

  on(ShippingConditionActions.fetchFailed, asyncFailed()),

  on(
    ShippingConditionActions.fetchSuccess,
    asyncSuccess(({ payload }, state) => ({
      payload: {
        ...adapterShippingCondition.setAll(payload, state.payload),
      },
    })),
  ),

  on(
    ShippingConditionActions.setActive,
    asyncState(({ shippingConditionId }, state) => ({
      payload: {
        ...state.payload,
        activeEntityId: shippingConditionId,
      },
    })),
  ),

  on(ShippingConditionActions.resetShippingConditionState, (state) => ({
    ...initialShippingConditionState,
  })),
);

export function reducer(state: ShippingConditionState | undefined, action: Action) {
  return shippingConditionReducer(state, action);
}
